export default "__VITE_ASSET__CETRbbKd__"